import { Direction } from "@app/models/direction.model";

export interface ISupply {
  supplyId?: string | null
  agreementId?: string | null
  agreementNum?: string | null
  procurementUrl?: string | null
  supplyNum?: string | null
  type?: string | null
  status?: string | null
  deliveryDate?: string | null
  actualDeliveryDate?: string | null
  warehouseId?: string | null
  warehouseName?: string | null
  budgetYear?: number | null
  budgetName?: string | null
  supplierName?: string | null
  residency?: string | null
  logisticManager?: string | null
  vatRate?: string | null
  directions?: Direction[] | null
  subDirections?: string[] | null
  mnnNames?: string[]

}

export class Supply implements ISupply {

  constructor(model?: Partial<ISupply>) {
    if (model) {
      Object.assign(this, model);
    }
  }

  supplyId?: string | null;
  agreementId?: string | null;
  agreementNum?: string | null;
  procurementUrl?: string | null;
  supplyNum?: string | null;
  type?: string | null;
  status?: string | null;
  deliveryDate?: string | null;
  actualDeliveryDate?: string | null;
  warehouseId?: string | null;
  warehouseName?: string | null;
  budgetYear?: number | null;
  budgetName?: string | null;
  supplierName?: string | null;
  residency?: string | null;
  logisticManager?: string | null;
  vatRate?: string | null;
  directions?: Direction[] | null;
  subDirections?: string[] | null;
  mnnNames?: string[];

}
